export const IMPRESSIONS = 0;
export const INSTALLS = 1;
export const EVENTS = 2;
export const CLICKS = 3;
export const PERCENT_GROUP = 4;
export const USD_AMOUNT_SMALL = 5;
export const USD_AMOUNT_BIG = 6;
export const USD_AMOUNT_MIDDLE = 7;
export const PERCENTEGE = -1;

export const CHANGE_RATE = -2;
